import { render, staticRenderFns } from "./centerRight3.vue?vue&type=template&id=7dc1caaf&scoped=true&"
import script from "./centerRight3.vue?vue&type=script&lang=js&"
export * from "./centerRight3.vue?vue&type=script&lang=js&"
import style0 from "./centerRight3.vue?vue&type=style&index=0&id=7dc1caaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc1caaf",
  null
  
)

export default component.exports